module.exports = __webpack_public_path__ + "assets/img/index-partner30.1e3f17d8.jpg";